"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@headlessui/react");
var classnames_1 = require("classnames");
var react_2 = require("react");
var Avatar_1 = require("../Avatar");
var buttons_1 = require("../buttons");
var Typography_1 = require("../Typography");
var DropdownItem_1 = require("./DropdownItem");
var Dropdown = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'outlined-alt' : _b, icon = _a.icon, iconOutlined = _a.iconOutlined, items = _a.items, _c = _a.size, size = _c === void 0 ? 'md' : _c, sections = _a.sections, onChange = _a.onChange, title = _a.title, subTitle = _a.subTitle, avatar = _a.avatar, showAvatar = _a.showAvatar, _d = _a.anchorPosition, anchorPosition = _d === void 0 ? 'left' : _d, menuClassName = _a.menuClassName, buttonClassName = _a.buttonClassName, renderItem = _a.renderItem, hideChevron = _a.hideChevron, dataTestId = _a["data-testid"], disabled = _a.disabled;
    var _e = (0, react_2.useState)(false), isOpen = _e[0], setIsOpen = _e[1];
    var toggleButtonRef = (0, react_2.useRef)(null);
    var menuRef = (0, react_2.useRef)(null);
    (0, react_2.useEffect)(function () {
        var handleClickOutside = function (event) {
            var _a;
            if (!((_a = toggleButtonRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) &&
                !['svg', 'path'].includes(event.target.tagName)) {
                setIsOpen(false);
            }
        };
        window.addEventListener('click', handleClickOutside);
        return function () {
            window.removeEventListener('click', handleClickOutside);
        };
    }, [toggleButtonRef, menuRef]);
    (0, react_2.useEffect)(function () {
        if (!menuRef.current) {
            return;
        }
        var menu = menuRef.current;
        var toggleButton = toggleButtonRef.current;
        if (window.innerHeight <
            menu.getBoundingClientRect().bottom + toggleButton.offsetHeight) {
            if (window.scrollY >
                menu.getBoundingClientRect().top -
                    menu.offsetHeight -
                    toggleButton.offsetHeight) {
                menu.style.top = "-".concat(menu.offsetHeight + toggleButton.offsetHeight, "px");
            }
            else {
                menu.style.top = "-".concat(menu.offsetHeight, "px");
            }
        }
        else {
            menu.style.top = '100%';
        }
    }, [menuRef, toggleButtonRef, isOpen]);
    var menus = (0, react_2.useMemo)(function () {
        var merged = (items === null || items === void 0 ? void 0 : items.length) > 0 ? [items] : [];
        return (sections === null || sections === void 0 ? void 0 : sections.length) ? __spreadArray(__spreadArray([], merged, true), sections, true) : merged;
    }, [items, sections]);
    var iconInItems = !!menus.find(function (m) { return !!m.find(function (i) { return !!i.leftIcon; }); });
    var handleChange = function (item) { return function () {
        onChange === null || onChange === void 0 ? void 0 : onChange(item);
        setIsOpen(false);
    }; };
    var handleToggle = function () {
        setIsOpen(!isOpen);
    };
    var style = {
        top: toggleButtonRef.current
            ? toggleButtonRef.current.offsetTop + toggleButtonRef.current.offsetHeight
            : 0,
    };
    if (anchorPosition === 'left') {
        style.left = toggleButtonRef.current
            ? toggleButtonRef.current.offsetLeft
            : 0;
    }
    else if (anchorPosition === 'right') {
        style.right = toggleButtonRef.current
            ? toggleButtonRef.current.offsetRight
            : 0;
    }
    var hasLabel = !!avatar ||
        showAvatar ||
        (!avatar && !showAvatar && (!!title || !!subTitle));
    return ((0, jsx_runtime_1.jsx)(react_1.Menu, __assign({ as: "div", className: "squid-relative" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "squid-relative squid-inline-block" }, { children: [(0, jsx_runtime_1.jsx)(react_1.Menu.Button, __assign({ as: "div", role: "button", "aria-label": title, onClick: disabled ? undefined : handleToggle, ref: toggleButtonRef }, { children: function () {
                        var buttonIcon;
                        if (!hideChevron) {
                            buttonIcon = isOpen ? 'ChevronUp' : 'ChevronDown';
                        }
                        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: variant === 'text' ? ((0, jsx_runtime_1.jsx)(buttons_1.SimpleButton, { variant: "default", leftIcon: icon, leftIconOutlined: iconOutlined, rightIcon: buttonIcon, title: title, "aria-label": title, className: buttonClassName, titleClassName: "squid-whitespace-nowrap", active: isOpen, "data-testid": "".concat(dataTestId, "Button"), disabled: disabled })) : ((0, jsx_runtime_1.jsx)(buttons_1.Button, __assign({ variant: variant, leftIcon: icon, leftIconOutlined: iconOutlined, rightIcon: !title && !subTitle ? undefined : buttonIcon, size: size, className: (0, classnames_1.default)({
                                    '!squid-p-2': !!avatar || showAvatar,
                                }, buttonClassName), active: isOpen, "data-testid": "".concat(dataTestId, "Button"), disabled: disabled }, { children: hasLabel && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "squid-flex squid-text-left" }, { children: [(avatar || showAvatar) && ((0, jsx_runtime_1.jsx)(Avatar_1.Avatar, { src: avatar !== null && avatar !== void 0 ? avatar : '', size: size, fullName: title !== null && title !== void 0 ? title : '', description: subTitle !== null && subTitle !== void 0 ? subTitle : '', displayFullName: !!title || !!subTitle })), !avatar && !showAvatar && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "squid-flex squid-flex-col" }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ strong: true, className: "squid-whitespace-nowrap" }, { children: title })), (0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ strong: false, className: "squid-whitespace-nowrap" }, { children: subTitle }))] })))] }))) }))) }));
                    } })), isOpen && ((0, jsx_runtime_1.jsx)(react_1.Menu.Items, __assign({ className: (0, classnames_1.default)("\n            squid-absolute \n        squid-z-50 \n        squid-mt-2 \n        squid-border \n        squid-p-component-dropdown-menu-padding \n        squid-border-alias-color-border-base \n        squid-bg-alias-color-bg-base \n        squid-rounded-component-dropdown-menu-border-radius \n        squid-divide-y\n        squid-divide-gray-100", {
                        'squid-right-0': anchorPosition === 'right',
                        'squid-origin-top-right': anchorPosition === 'right',
                        'squid-left-0': anchorPosition === 'left',
                        'squid-origin-top-left': anchorPosition === 'left',
                        'squid-block': isOpen,
                        'squid-overflow-auto squid-max-h-60': isOpen,
                    }, menuClassName), ref: menuRef, style: style }, { children: menus.map(function (menu, index) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "squid-gap-component-dropdown-space squid-flex squid-flex-col" }, { children: menu.map(function (item, index) {
                            return ((0, jsx_runtime_1.jsx)(DropdownItem_1.default, { item: item, onClick: handleChange(item), renderItem: renderItem, indent: iconInItems, "data-testid": "".concat(dataTestId, "_").concat(item.label) }, item.label + index));
                        }) }), index)); }) })))] })) })));
};
exports.Dropdown = Dropdown;
